<mc-form [formGroup]="AIForm" [submitFn]="submitFn" [loadingState]="loadingState" (cancel)="cancel.emit()" successMessage="OpenAI settings have been saved" errorMessage="Unable to update the OpenAI settings.">
  <ng-template mcFormBody>
    <h4 class="mc-form-heading">ChatGPT</h4>
    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>API Key</mat-label>
      <input type="text" class="mc-form-password-input-edge-eye-hidden" matInput formControlName="key" placeholder="API Key" [type]="hide ? 'password' : 'text'">
      <mat-error>
        <mc-form-control-error-message [form]="AIForm" controlName="key" type="mc_open_ai_settings"></mc-form-control-error-message>
      </mat-error>
      <mat-icon fontSet="project-titan" matIconSuffix fontIcon="icon-eye-open" (click)="hide = !hide"></mat-icon>
    </mat-form-field>
    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>Version</mat-label>
      <mat-select matInput formControlName="version">
        <mat-option *ngFor="let model of models" [value]="model.value">
          {{model.text}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <p class="mc-form-text">
      <span class="text-medium-weight">Note: </span>
      MadCap Software is not responsible for results you might receive from ChatGPT, which is a third-party tool. This includes the possibility of occasional inaccuracies, bias in training data, and privacy/security issues. Please refer to the OpenAI privacy and security policies, as well as their documentation, for more information.
    </p>
  </ng-template>
</mc-form>